import { useTranslation } from "react-i18next";
import TmpxLogsData from "./tmpxLogsData";

const formatDateTime = (value) => {
  if (!value) return "-";

  const date = new Date(value);
  if (isNaN(date)) return "-";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const TmpxLogsOverviewTable = () => {
  const { t } = useTranslation();
  const { data, loading, error } = TmpxLogsData();

  const columns = [
    { Header: t("scenarios.tmpxLogs.columns.id"), accessor: "id", width: "8%" },
    { Header: t("scenarios.tmpxLogs.columns.name"), accessor: "name", width: "28%" },
    { Header: t("scenarios.tmpxLogs.columns.datetimeOfExchange"), accessor: "datetime_of_exchange", width: "16%" },
    { Header: t("scenarios.tmpxLogs.columns.datetimeOfUpdate"), accessor: "datetime_of_update", width: "16%" },
    { Header: t("scenarios.tmpxLogs.columns.version"), accessor: "version", width: "10%" },
    { Header: t("scenarios.tmpxLogs.columns.to"), accessor: "to", width: "10%" },
    { Header: t("scenarios.tmpxLogs.columns.status"), accessor: "status", width: "12%" },
  ];

  const rows = (data || []).map((item) => ({
    id: item.scenario_id ?? "-",
    name: item.scenario_name ?? "-",
    datetime_of_exchange: formatDateTime(item.enabled_at),
    datetime_of_update: formatDateTime(item.updated_at),
    version: item.current_version ?? "-",
    to: item.to ?? "-",
    status: item.status ?? "-",
  }));

  return {
    tableData: { columns, rows },
    loading,
    error,
  };
};

export default TmpxLogsOverviewTable;
